<script>
import { ref } from 'vue';
import MainHeaderLogo from "@/components/MainHeader/MainHeaderLogo.vue";
import MainHeaderUserButton from "@/components/MainHeader/MainHeaderUserButton.vue";
import MainHeaderBasketButton from "@/components/MainHeader/MainHeaderBasketButton.vue";
import MainHeaderMenuNav from "@/components/MainHeader/MainHeaderMenuNav.vue";
import ThemeToggle from "@/components/MainHeader/ThemeToggle.vue";

export default {
  name: "MainHeader",
  components: { MainHeaderMenuNav, MainHeaderBasketButton, MainHeaderUserButton, MainHeaderLogo, ThemeToggle },
  setup() {
    const mobileMenuOpen = ref(false);
    return { mobileMenuOpen };
  }
}
</script>

<template>
  <div class="mainHeader">
    <div class="mainHeader__bar">
      <MainHeaderLogo/>
      <div class="mainHeader__rightPart">
        <MainHeaderMenuNav class="mainHeader__navDesktop"/>
        <MainHeaderBasketButton class="mainHeader__basketDesktop"/>
        <ThemeToggle class="mainHeader__themeToggle"/>
        <MainHeaderUserButton/>
        <button
          class="mainHeader__burger"
          :class="{ 'mainHeader__burger--open': mobileMenuOpen }"
          @click="mobileMenuOpen = !mobileMenuOpen"
          aria-label="Открыть меню"
        >
          <span class="mainHeader__burgerBar"/>
          <span class="mainHeader__burgerBar"/>
          <span class="mainHeader__burgerBar"/>
        </button>
      </div>
    </div>
    <div class="mainHeader__mobileMenu" v-show="mobileMenuOpen">
      <MainHeaderMenuNav/>
      <MainHeaderBasketButton/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mainHeader {
  &__bar {
    height: 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__rightPart {
    display: flex;
    gap: 1.5rem;
    align-items: center;
  }

  // ── Desktop-only elements ──────────────────────────────────────────────────
  &__navDesktop,
  &__basketDesktop {
    @include respond-to('md') { display: none; }
  }

  // ── Hamburger button ───────────────────────────────────────────────────────
  &__burger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    padding: 8px;
    background: transparent;
    border: none;
    cursor: pointer;

    @include respond-to('md') { display: flex; }
  }

  &__burgerBar {
    display: block;
    width: 100%;
    height: 2px;
    background: var(--cd-highlight-text);
    border-radius: 2px;
    transition: transform 0.25s ease, opacity 0.25s ease;
    transform-origin: center;
  }

  &__burger--open {
    .mainHeader__burgerBar:nth-child(1) { transform: translateY(7px) rotate(45deg); }
    .mainHeader__burgerBar:nth-child(2) { opacity: 0; }
    .mainHeader__burgerBar:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }
  }

  // ── Mobile dropdown ────────────────────────────────────────────────────────
  &__mobileMenu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: $space-sm;
    padding: $space-sm 0;
    border-top: 1px solid var(--cd-spoiler-border-color);

    // Always hidden on desktop
    @media (min-width: calc(#{$bp-md} + 1px)) {
      display: none !important;
    }
  }
}
</style>
